import { getConflictCode, getResponseDetail } from './apiErrorDetail';
import { getHttpStatus } from './httpErrorUtils';

/** A visit still open when a reopened episode is marked completed (EMR-2433). */
export type EpisodeUnfinishedVisit = {
  task_id: string;
  label: string;
  visit_date: string | null;
  status: string;
};

/**
 * The completion 409 carries the unfinished visits in a structured `detail`
 * object, like the episode-edit impact 409. Returns null for any other error.
 */
export const parseEpisodeUnfinishedVisits = (
  error: unknown
): EpisodeUnfinishedVisit[] | null => {
  if (getHttpStatus(error) !== 409) {
    return null;
  }
  const detail = getResponseDetail(error);
  if (getConflictCode(detail) !== 'episode_unfinished_visits') {
    return null;
  }
  const visits = (detail as { visits?: unknown }).visits;
  return Array.isArray(visits) ? (visits as EpisodeUnfinishedVisit[]) : null;
};
